/** Roof pieces share the building grid's neighbour indices, and draw on the sky layer. */
export interface RoofAutotileDefinition {
    id: string
    name: string
    kind: "roof"
    tilesetId: string
    itemType: string
    tiles: Record<number, number>
}

/** The original wooden roof mapping, preserved for existing roof-wood buildings. */
const woodenTiles: Record<number, number> = {47: 468, 42: 449, 36: 464, 46: 465, 12: 481, 28: 466, 34: 448, 26: 450, 7: 480, 4: 482, 18: 451, 8: 452, 15: 453, 14: 467, 6: 483, 3: 484, 5: 455, 2: 454, 13: 485, 1: 469, 21: 404, 9: 420, 19: 435, 16: 436, 29: 416, 37: 417, 17: 466, 22: 419, 20: 464, 10: 481, 27: 466, 35: 464, 11: 481}
export const roofHasTrigger = (index: number): boolean => !!index && ![18, 8, 15, 14, 6, 3, 34, 26, 42, 28, 13, 1, 5, 2].includes(index)
export const roofCellTile = (definition: RoofAutotileDefinition | undefined, index: number) => ({
    tilesetId: definition?.tilesetId || "fence_medieval",
    tilePos: definition ? definition.tiles[index] : woodenRoofTile(index),
})
export const woodenRoofTile = (index: number): number => woodenTiles[index] ?? 465
